/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { WhatsAppSolutionAssociationVerificationSource } from './WhatsAppSolutionAssociationVerificationSource';
/**
 * Conclusive evidence matching the requested Meta solution association.
 */
export type WhatsAppSolutionAssociationVerified = {
    /**
     * Meta signal used to classify the solution association.
     */
    source: WhatsAppSolutionAssociationVerificationSource;
    /**
     * Solution identifier expected for this onboarding attempt.
     */
    expectedSolutionId: string;
    /**
     * Whether the expected solution association should be present.
     */
    expectedPresent: boolean;
    /**
     * ISO timestamp when the evidence was checked.
     */
    checkedAt: string;
    /**
     * Evidence classification.
     */
    status: WhatsAppSolutionAssociationVerified.status;
    /**
     * Whether Meta reported the expected solution association as present.
     */
    observedPresent: boolean;
};
export namespace WhatsAppSolutionAssociationVerified {
    /**
     * Evidence classification.
     */
    export enum status {
        VERIFIED = 'verified',
    }
}

